import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { DonleeFechtAPI } from '../../api/Donlee';
import ErrorAlert from '../Alerts/ErrorAlert';
import { RenderIf } from '../utils/RenderIf';

import Accordion from 'react-bootstrap/Accordion';

function ModuleTips({ invoiceTips, setInvoiceTips, recomendationTips, setEventHandler }) {
    const [showModal, setShowModal] = useState(false)
    let token = localStorage.getItem('x-access-machine-token');

    const handlerInputText = (value) => {
        let input = document.getElementById('inputTips')
        input.value = value
    }

    const handleChange = (e) => {

        if (e.target.value == "") {
            setInvoiceTips(0.00)
        } else {
            setInvoiceTips(parseFloat(e.target.value))
        }

        setEventHandler(1)

    }



    return (
        <>

            <div class="card">
                <div className='d-flex justify-content-between align-items-center gap-2'>
                    <div>
                        <h3 className="text-primary small fw-bold">   Propina: ${invoiceTips}</h3>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <input id="inputTips" type="number" step='0.01' className="form-control form-control-sm" placeholder='Ingrese un monto' onChange={(e) => handleChange(e)} />
                    </div>
                </div>
                <div class="card-body p-0">
                    <div className='w-100 '>
                        <span className='text-primary small text-center '>Propina recomendada</span>
                        <div className='d-flex pverflow-x flex-wrap'>

                            <div className=" col-md-3 d-flex  p-2 text-center" onClick={() => (handlerInputText(0.00), setInvoiceTips(0.00), setEventHandler(1))}>
                                <span className="text-muted border border-2 rounded-3 p-1  w-100 bg-light"> Propina 0%:<br></br> $
                                    <span translate='no' className='fw-bold'>0.00</span>
                                </span>
                            </div>
                            {recomendationTips.map((tip) => (<>
                                <div className=" col-md-3 d-flex  p-2 text-center"
                                    onClick={() => (handlerInputText(tip.value), setInvoiceTips(tip.value), setEventHandler(1))}>
                                    <span className="text-muted border border-2 rounded-3 p-1  w-100 bg-light">
                                        Propina {tip.rate}:<br></br> $
                                        <span translate='no' className='fw-bold'>{tip.value}</span>
                                    </span>
                                </div>

                                {/* <div className="btn-group my-1 ms-1" role="group" >
                                    <input
                                        className="btn-check-sp input-visually-hidden"
                                        type={"radio"}
                                        onClick={() => (handlerInputText(tip.value), setInvoiceTips(tip.value), setEventHandler(1))}

                                    />
                                    <label
                                        htmlFor=""
                                        className={`btn btn-choice p-lg-2 p-1  border `}>
                                        <div className='d-lg-flex align-items-lg-center  justify-content-lg-start flex-nowrap d-grid '>
                                            <span>
                                                Propina {tip.rate}:<br></br> $
                                                <span translate='no' className='fw-bold'>{tip.value}</span>
                                            </span>
                                        </div>
                                    </label>
                                </div> */}
                            </>))}
                        </div>
                    </div>
                </div>
            </div>


            {/* <div
                show={showModal}
                size="md"
                onHide={() => setShowModal(true)}
                aria-labelledby="example-custom-modal-styling-title"
                centered
            >

                <Modal.Body>


                    <div className='row'>*/}




            {/* Propina: ${invoiceTips}
                <div className='row'>
                    <div className=' col-sm-8'>
                        <input id="inputTips" type="number" step='0.01' className="form-control border" placeholder='Ingrese un monto' onChange={(e) => handleChange(e)} />
                    </div>

                </div> */}






            {/*</div>
                </Modal.Body>
            </div>*/}
        </>
    )
}

export default ModuleTips